<template>
  <div id="rm-header">
    <header>
      <div class="logo" v-if="!isAuthorized">
        <a :href="`${homeUrl}`">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            x="0px"
            y="0px"
            viewBox="0 0 1024 1024"
            style="box-shadow: none; border-radius: 0px; opacity: 1; display: inline;"
            xml:space="preserve"
            preserveAspectRatio="xMidYMid meet"
            fill="#ec520b"
            fill-opacity="1"
          >
            <g>
              <circle cx="512" cy="512" r="512" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#ffffff"
                class="st0"
                d="M743,754.5v-79.7c0-15.9-8.7-23.9-23.1-23.9c-17.1,0-31.2,12.7-31.8,28.1v75.4h-28.9v-79.7   c0-15.9-8.7-23.9-23.1-23.9c-17.1,0-31.2,12.7-31.8,28.1v75.4h-28.9V629.7h26l2.9,10.6l1.4,1.3l1.4-1.3c5.8-8,20.2-13.3,31.8-13.3   c20.8,0,35.8,8.2,43.4,21.2l7.2-8c7.2-8,21.7-13.3,33.2-13.3c31.8,0,49.2,18.6,49.2,45.1v82.3H743z M265.9,748l484.8-484.8   l10.1,10.1L276,758.1L265.9,748z M303.1,366.4h-5.3v86h-28.4V252.1h69c31,0,58.2,20.6,58.2,56.2c0,34.3-29,56.2-60,56.2l63.8,82.3   v5.5H368L303.1,366.4z M340,338c15.6,0,29.9-10.9,29.9-28.6c0-17.7-14.3-28.6-29.9-28.6h-41.6V338H340z"
              />
            </g>
          </svg>
        </a>
      </div>

      <div class="avatar" v-if="isAuthorized">
        <a :href="profileUrl" :style="{ backgroundImage: userpic && `url('${addAvatarSizeSuffix(userpic, 48)}')` }">
          {{ userpic ? '' : initials }}
        </a>
      </div>

      <div class="links">
        <a :href="`${homeUrl}/features`" :class="{ active: activeLink === 'features' }">Features</a>
        <a :href="`${homeUrl}/pricing/`" :class="{ active: activeLink === 'pricing' }">Pricing</a>
        <a :href="`${homeUrl}/explore/`" :class="{ active: activeLink === 'examples' }">Examples</a>
        <a href="https://learn.readymag.com/" :class="{ active: activeLink === 'learn' }">Learn</a>
      </div>

      <div class="buttons" v-if="isAuthorized">
        <a :href="`${profileUrl}/logout`">Log out</a>
      </div>

      <div class="buttons" v-if="!isAuthorized">
        <a :href="`${homeUrl}/join/`">Join</a>
        <a :href="`${homeUrl}/login/`">Log in</a>
      </div>
    </header>
  </div>
</template>

<script>
import $ from '@rm/jquery';
import _ from '@rm/underscore';
import Vue from 'vue';
import { Utils, Constants } from '../../js/common/utils';
import RmHeaderMobile from './rm-header-mobile.vue';

const availableSizes = [64, 96, 128, 192, 256];

const getActualSize = size => {
  const size2x = size * 2;
  return availableSizes.reduce(
    (closestSize, currentSize) => (size2x <= currentSize && size2x > closestSize ? currentSize : closestSize),
    availableSizes[0]
  );
};

export default {
  data: () => ({
    isAuthorized: false,
    userpic: null,
    username: null,
    profileUrl: Constants.readymag_auth_host,
    homeUrl: Constants.readymag_host,
  }),

  props: {
    activeLink: String,
  },

  computed: {
    initials() {
      const name = this.username;
      if (!name) return '';

      const [firstName, lastName] = name.split(' ');
      return lastName ? firstName[0] + lastName[0] : firstName[0];
    },
  },

  mounted: function() {
    // Мобильная шапка должна жить в body, чтобы быть выше всех и не реагировать на scale layout
    const MobileHeader = Vue.extend(RmHeaderMobile);
    const $mobileHeaderContainer = $('<div>').appendTo('body');

    this.mobileVue = new MobileHeader({
      el: $mobileHeaderContainer[0],

      propsData: {
        activeLink: this.activeLink,
      },
    });

    Utils.loadLoggedUser(user => {
      this.isAuthorized = !_.isEmpty(user);
      this.userpic = user && user.pic;
      this.username = user && user.name;
      this.mobileVue.isAuthorized = this.isAuthorized;
    });
  },

  methods: {
    addAvatarSizeSuffix: (url, size) => {
      if (!url) return '';

      const extension = url.split('.').pop();
      const actualSize = getActualSize(size);
      return url && actualSize ? url.replace(`.${extension}`, `_${actualSize}.${extension}`) : '';
    },

    destroyMobile: function() {
      $(this.mobileVue.$el).remove();
      this.mobileVue.$destroy();
    },
  },
};
</script>

<style lang="less">
@orange: #ec520b;
@font: Graphik;

#rm-header {
  header {
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    box-sizing: border-box;
    cursor: default;

    > div {
      width: 100%;
    }
  }

  .logo {
    height: 40px;

    a {
      display: inline-block;
      height: 40px;

      &:hover {
        svg {
          transform: rotate(360deg);
        }
      }
    }

    svg {
      height: 40px;
      width: 40px;
      transition: transform 0.6s ease-in-out;
    }
  }

  .avatar {
    height: 40px;
    display: inline-block;

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      text-decoration: none;
      background-color: #f4f4f4;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      height: 40px;
      width: 40px;
      border-radius: 50%;

      font-weight: 400;
      font-size: 16px;
      line-height: 1.25;
      letter-spacing: -0.04px;
      color: rgb(40, 40, 40);
      text-transform: uppercase;
      font-family: @font;
    }
  }

  .links {
    text-align: center;

    a {
      display: inline-block;
      font-family: @font;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      margin-right: 16px;
      text-decoration: none;
      color: #000;

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        color: @orange;
      }
    }

    a.active {
      color: @orange;
      cursor: default;
      pointer-events: none;
    }
  }

  .buttons {
    text-align: right;
    font-size: 0;

    a {
      background-color: rgba(244, 244, 244, 0.96);
      border-radius: 200px;
      width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-family: @font;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      display: inline-block;
      border: none;
      outline: none;
      cursor: pointer;
      padding: 0;
      text-decoration: none;
      color: #000;

      &:hover {
        color: #fff;
        background-color: @orange;
      }
    }
  }
}

.rm-header-mobile {
  #rm-header {
    header {
      align-items: center;
      padding: 6px 6px;

      .avatar {
        width: auto;
        height: 48px;

        a {
          height: 48px;
          width: 48px;
        }
      }

      .logo {
        height: 48px;

        a {
          height: 48px;
        }

        svg {
          height: 48px;
          width: 48px;
        }
      }

      .links {
        display: none;
      }

      .buttons {
        display: none;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .rm-header-mobile;

  .widget-rm-header {
    width: 100% !important;
    left: 0 !important;
    top: 0 !important;
    margin-left: 0 !important;
  }
}
</style>
